import sanitizeHtml from 'sanitize-html';

export function useSanitizeHtml(text: string) {
  return sanitizeHtml(text, {
    allowedTags: [ 'b', 'i', 'em', 'strong', 'a' , 'br', 'ul', 'li', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6' ],
    allowedAttributes: {
      'a': [ 'href' ]
    }
  });
};
